'use client';
import { Button, message, Modal, Radio } from 'antd';
import { Input } from 'antd/lib';
import { GlobalContext } from 'context';
import { API } from 'data';
import { useContext, useState } from 'react';
import { RestAPI, useAsyncClick } from 'scripts';
import styles from './report.module.scss';
import { TbX } from 'react-icons/tb';
import { __PostSpamModalPropsType } from './report.type';

const reportOptions = ['کلاهبرداری', 'رفتار غیر اخلاقی', 'رفتار توهین آمیز', 'سایر'];

export default function PostReportComp(props: __PostSpamModalPropsType) {
    const { profile } = useContext(GlobalContext);
    const [problem, setProblem] = useState();
    const [otherDescription, setOtherDescription] = useState('');

    const onOkHandler = useAsyncClick(() => {
        return new Promise((resolve) => {
            if (!profile) {
                message.error('لطفا برای ثبت گزارش وارد حساب خود شوید.');
                resolve(false);
                return;
            }
            if (problem === reportOptions[reportOptions.length - 1] && !otherDescription.length) {
                message.error('لطفا توضیحات گزارش خودرا پرکنید.');
                resolve(false);
                return;
            }
            RestAPI.post(API.chat.report, {
                chat: props.chatID,
                description: problem === reportOptions[reportOptions.length - 1] ? otherDescription : problem,
            })
                .then(() => {
                    message.success('گزارش شما با موفقیت ثبت شد.');
                    props.onSubmit();
                    resolve(true);
                })
                .catch(() => {
                    message.error('عملیات با خطا مواجه شد لطفا بعدا دوباره تلاش کنید.');
                    resolve(false);
                });
        });
    });

    return (
        <Modal
            width={400}
            open={props.chatID ? true : false}
            onCancel={() => props.onClose()}
            closeIcon={null}
            footer={
                <Button {...onOkHandler} className={`${styles['btn-submit']}`}>
                    تایید
                </Button>
            }
        >
            <div className={`${styles['spam-content']}`}>
                <div className={`${styles['header']} center-content-y justify-content-between`}>
                    <p className="t-h3 t-500 t-d-gray3-i">گزارش و مسدودسازی</p>
                    <Button type="primary" icon={<TbX size={20} />} onClick={() => props.onClose()} />
                </div>
                <div className="flex-column center-content-x g-3 mt-3">
                    <p className="t-h2 t-600 t-d-gray3-i">چه مشکلی وجود دارد؟</p>
                    <Radio.Group
                        name="radiogroup"
                        className="flex-column center-content-x g-2"
                        defaultValue={1}
                        options={reportOptions.map((i) => ({ label: i, value: i }))}
                        onChange={(e) => setProblem(e.target.value)}
                    />
                    {problem === reportOptions[reportOptions.length - 1] ? (
                        <Input.TextArea
                            value={otherDescription}
                            onChange={(e) => setOtherDescription(e.target.value)}
                            placeholder="توضیحات..."
                        />
                    ) : null}
                </div>
            </div>
        </Modal>
    );
}
